import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBetCombo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18.83 17.316",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Combo v3",
		transform: "translate(0.089 0.296)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5682",
				d: "M6.87,8.92A5.414,5.414,0,0,0,2.918,6.75H.75",
				transform: "translate(-0.339 -3.448)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5683",
				d: "M18.58,6.75h-4.1c-3.614,0-5.783,5.06-5.783,5.06s-2.168,5.06-5.783,5.06H.75",
				transform: "translate(-0.339 -3.448)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5684",
				d: "M21.05,23.254A5.407,5.407,0,0,0,25,25.421h4.1",
				transform: "translate(-10.857 -11.999)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5685",
				d: "M31.75.75l2.891,2.891L31.75,6.533",
				transform: "translate(-16.4 -0.339)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5686",
				d: "M31.75,21.75l2.891,2.891L31.75,27.533",
				transform: "translate(-16.4 -11.219)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	})
});
export { SvgBetCombo as ReactComponent };
